/**
 * 商品カード上の Judge.me プレビューバッジを「( 1 )」形式（括弧内スペース付き）に整形する。
 * アプリが後から DOM を差し替えるため MutationObserver で追従する。
 */
(function () {
  'use strict';

  var SELECTOR = '.product-item .jdgm-prev-badge__text';
  var scheduled = false;

  function normalize(el) {
    if (!el || typeof el.textContent !== 'string') return;
    if (!el.closest || !el.closest('.product-item')) return;
    var t = el.textContent.replace(/\s+/g, ' ').trim();
    var m = t.match(/\d+/);
    if (!m) return;
    var desired = '( ' + m[0] + ' )';
    if (t === desired) return;
    el.textContent = desired;
  }

  function run() {
    document.querySelectorAll(SELECTOR).forEach(normalize);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  if (typeof MutationObserver === 'undefined') return;

  var obs = new MutationObserver(schedule);
  function startObserver() {
    if (!document.body) return;
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    schedule();
  }

  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
})();
